import React, { FC, memo } from "react";
import { isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";
import { useTheme } from "styled-components";
import Tooltip from "../Tooltip/Tooltip";
import { Wrapper } from "./PackageTypeIcon.styles";

interface PackageTypeIconProps {
  type: string;
}

enum PackageType {
  Box = "box",
  Bag = "bag",
}

const BoxIcon: FC = () => {
  const theme = useTheme();
  return (
    <svg viewBox="0 0 27.1 27.7" xmlns="http://www.w3.org/2000/svg">
      <path
        fill={theme.packageBoxBg}
        d="M25.6,26h-24V2h24V26z M13.7,9.4c-2.5-0.1-4.6,1.8-4.7,4.3c-0.1,2.5,1.8,4.6,4.3,4.7c2.5,0.1,4.6-1.8,4.7-4.3S16.2,9.5,13.7,9.4z"
      />
    </svg>
  );
};

const BagIcon: FC = () => {
  const theme = useTheme();
  return (
    <svg viewBox="0 0 27.1 27.7" xmlns="http://www.w3.org/2000/svg">
      <circle fill={theme.packageBagBg} cx="13.6" cy="14.1" r="12" />
      <circle fill={theme.packageBagDot} cx="13.6" cy="14" r="4.5" />
    </svg>
  );
};

const PackageTypeIcon: FC<PackageTypeIconProps> = ({ type }) => {
  const { t } = useTranslation("common");

  const tooltipBody = ((type) => {
    switch (type) {
      case PackageType.Box:
      default:
        return t("tooltips.shipmentIsBox");
      case PackageType.Bag:
        return t("tooltips.shipmentIsBag");
    }
  })(type);

  return (
    <Tooltip
      body={tooltipBody}
      place="bottom"
      openEvents={{
        click: isMobile,
        mouseover: !isMobile,
        focus: !isMobile,
      }}
    >
      <Wrapper>
        {type === PackageType.Bag ? <BagIcon /> : <BoxIcon />}
      </Wrapper>
    </Tooltip>
  );
};

export default memo(PackageTypeIcon);
